import { MCIP_STATIC_DATA_URL } from "../config/environment"

export const QA = {
  get: () => {
    return fetch(`${MCIP_STATIC_DATA_URL}/json/faq.json`)
      .then(response => response.json())
  },
}
